module.exports = __webpack_public_path__ + "9b83d54965dd96327f43997986ab294b.fbx";